import { DocumentNode, gql } from '@apollo/client'

export const CREATE_MULTIPLE_WORK: DocumentNode = gql`
    mutation CreateMultipleWork(
        $daycareId: Int!
        $staff: Int!
        $type: workType!
        $sectionGroupId: Int
        $internalNote: String
        $externalNote: String
        $from: Date
        $to: Date
        $days: [Int]
        $dateList: [Date]
        $start: Time
        $end: Time
        $staffPreparationTaskIdsBefore: [Int]
        $staffPreparationTaskIdsAfter: [Int]
        $pauseStart: Time
        $pauseEnd: Time
        $dayTimes: [DayTimeInput]
        $weekCycle: Int
        $weekOffsets: [Int]
        $referenceDate: Date
        $replaceExisting: Boolean
    ) {
        createMultipleWork(
            daycareId: $daycareId
            staff: $staff
            type: $type
            sectionGroupId: $sectionGroupId
            internalNote: $internalNote
            externalNote: $externalNote
            from: $from
            to: $to
            days: $days
            dateList: $dateList
            start: $start
            end: $end
            staffPreparationTaskIdsBefore: $staffPreparationTaskIdsBefore
            staffPreparationTaskIdsAfter: $staffPreparationTaskIdsAfter
            pauseStart: $pauseStart
            pauseEnd: $pauseEnd
            dayTimes: $dayTimes
            weekCycle: $weekCycle
            weekOffsets: $weekOffsets
            referenceDate: $referenceDate
            replaceExisting: $replaceExisting
        ) {
            createdIds
            skippedDates
        }
    }
`

export const DELETE_INTERNAL_WORK: DocumentNode = gql`
    mutation DeleteInternalWork($workId: Int!, $daycareId: Int!) {
        deleteInternalWork(workId: $workId, daycareId: $daycareId)
    }
`

export const UPDATE_INTERNAL_WORK: DocumentNode = gql`
    mutation UpdateInternalWork($workId: Int!, $work: InternalWorkInput!, $daycareId: Int!) {
        updateInternalWork(workId: $workId, work: $work, daycareId: $daycareId) {
            id
            date
            start
            end
            staff
            type
            sectionGroupId
            internalNote
            externalNote
            preparationTimeBefore
            preparationTimeAfter
            preparationTasksBefore {
                id
                daycareId
                name
                duration
            }
            preparationTasksAfter {
                id
                daycareId
                name
                duration
            }
            totalDuration
        }
    }
`
